import { spacing, spacingSizes } from '../../../theme';

export type Theme = {
  palette: {
    text: string;
    textSubtle: string;
    divider: string;
    background: {
      default: string;
    };
  };
  spacing: number;
  spacingSizes: {
    xxs: number;
    xs: number;
    sm: number;
    md: number;
    lg: number;
    xl: number;
    xxl: number;
    xxxl: number;
  };
};

const theme: Theme = {
  palette: {
    text: '#212121',
    textSubtle: '#757575',
    divider: '#E0E0E0',
    background: {
      default: '#FFFFFF',
    },
  },
  spacing,
  spacingSizes,
};

const opacity = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export default {
  ...theme,
  opacity,
  spacing: (...values: Array<number>) =>
    values.map((v) => `${v * theme.spacing}px`).join(' '),
};
